import React from 'react';

export function Button({ className = '', variant = 'primary', size, children, ...props }) {
  const sizeClass = size === 'sm' ? ' ui-button--sm' : size === 'lg' ? ' ui-button--lg' : '';
  return (
    <button
      type="button"
      className={`ui-button ui-button--${variant}${sizeClass} touch-target ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
